import React from "react";

export default input => (
	<div className="form-element ">
		<label
			className={`input input-checkbox ${input.error && (input.value !== undefined || input.displayError) ? "error" : ""} ${
				input.disabled ? "disabled" : ""
				} `}
			tabIndex="0"
		>
			<div className="group">
				<input type="checkbox" {...input} />
				<i class="svg-checkbox" role="checkbox" aria-label="Example checkbox" aria-checked="false">
          
		  <svg class="svg" width="24px" height="24px" viewBox="0 0 24 24">
			<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
			  <rect class="fill" height="20" rx="2" width="20" x="2" y="2"></rect>
			  <polyline class="stroke" points="7 13 10 16 17 8"></polyline>
			</g>
		  </svg>
		
	  </i>
				<span className="label-inline">{input.label}</span>
			</div>
			{input.error && (input.value !== undefined || input.displayError) && <p className="message">{input.error}</p>}
		</label>
	</div>
);
